module.exports = "https://static.wmbcdn.com/uniweb/images/144e731feb8733c2d208c75d0293ff2a.svg";